import { User } from "../../Domain/Model/User";
import { AuthRepository } from "../../Domain/Repository/AuthRepository";
import AuthDataSource from "../DataSource/AuthDataSource";

export class AuthRepositoryImpl implements AuthRepository {
  dataSource: AuthDataSource;

  constructor(_datasource: AuthDataSource) {
    this.dataSource = _datasource;
  }
    login(email: string, password: string): Promise<User> {
        return this.dataSource.login(email, password);
    }
    checkAuthStatus(token: string): Promise<boolean> {
        return this.dataSource.checkAuthStatus(token);
    }
}